import React from "react";
import AppButton from "@common/components/app-button";
import {XMarkIcon} from "@heroicons/react/20/solid";

interface ArticleTagProps {
    readonly?: boolean;
    text: string;
    onCancel?: () => void;
}

const ArticleTag = (props: ArticleTagProps) => {
    const {
        text,
        onCancel,
        readonly = true,
    } = props;

    return (
        <>
            {readonly ? (
                <span className="text-sm font-normal">{text}</span>
            ) : (
                <div>
                    <AppButton
                        className="cursor-auto !w-fit h-[32px] !p-0 !pl-3 bg-surface-level-1 hover:bg-on-surface/5 border border-outline rounded-lg text-sm font-semibold"
                    >
                        <div className="flex items-center gap-1">
                            {text}
                            <div
                                onClick={onCancel}
                                className="w-fit h-fit cursor-pointer hover:bg-on-surface/10 rounded-2xl p-1">
                                <XMarkIcon className="w-6 h-6 min-w-6"/>
                            </div>
                        </div>
                    </AppButton>
                </div>
            )}
        </>
    )
}

export default ArticleTag
